import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewSalesModal from "./ViewSalesModal";

function ViewSales({ item, currency }) {
  const [viewModal, setViewModal] = useState(false);
  const handleSingleFile = () => {
    setViewModal(true);
  };
  return (
    <td className="py-2 px-4 flex justify-center gap-3">
      <VisibilityIcon
        onClick={handleSingleFile}
        className="text-yellow-400 cursor-pointer"
      />
      {viewModal && (
        <ViewSalesModal
          item={item}
          currency={currency}
          setViewModal={setViewModal}
        />
      )}
    </td>
  );
}

export default ViewSales;
